import gql from 'graphql-tag';
import FragmentFeature from 'graphql/fragments/feature';

export default gql`
  mutation createFeature($key: String!, $appId: String!, $desc: String) {
    createFeature(input: { key: $key, appId: $appId, desc: $desc }) {
      ...FragmentFeature
    }
  }

  ${FragmentFeature}
`;
